module.exports = __webpack_public_path__ + "img/preview-machine-finder.18eb5f40.png";